import {
  FontColor,
  FontWeight,
  TextAlign,
  TextSize,
  TextTransform,
} from '@freelancer/ui/text';
import { cva } from 'class-variance-authority';

export const TEXT_WEIGHT_TAILWIND_VARIANTS: { [key in FontWeight]: string } = {
  [FontWeight.LIGHT]: 'font-light',
  [FontWeight.NORMAL]: 'font-normal',
  [FontWeight.MEDIUM]: 'font-medium',
  [FontWeight.BOLD]: 'font-bold',
  [FontWeight.BLACK]: 'font-black',
  [FontWeight.INHERIT]: 'font-weight-inherit',
};

export const TEXT_COLOR_TAILWIND_VARIANTS: { [key in FontColor]: string } = {
  [FontColor.FOREGROUND]: 'text-foreground',
  [FontColor.DARK]: 'text-dark',
  [FontColor.LIGHT]: 'text-light',
  [FontColor.PRIMARY]: 'text-primary',
  [FontColor.SUCCESS]: 'text-success',
  [FontColor.WARNING]: 'text-warning',
  [FontColor.ERROR]: 'text-error',
  [FontColor.INHERIT]: 'text-color-inherit',
};

export const TEXT_SIZE_TAILWIND_VARIANTS: { [key in TextSize]: string } = {
  [TextSize.XXXSMALL]: 'text-xxxsmall',
  [TextSize.XXSMALL]: 'text-xxsmall',
  [TextSize.XSMALL]: 'text-xsmall',
  [TextSize.SMALL]: 'text-small',
  [TextSize.MARKETING_SMALL]: 'text-marketing_small',
  [TextSize.MID]: 'text-mid',
  [TextSize.LARGE]: 'text-large',
  [TextSize.XLARGE]: 'text-xlarge',
  [TextSize.XXLARGE]: 'text-xxlarge',
  [TextSize.XXXLARGE]: 'text-xxxlarge',
  [TextSize.MARKETING_MEGA]: 'text-marketing_mega',
  [TextSize.MARKETING_XMEGA]: 'text-marketing_xmega',
  [TextSize.INHERIT]: 'text-size-inherit',
};

export const TEXT_SIZE_TAILWIND_TABLET_VARIANTS: {
  [key in TextSize]: string;
} = {
  [TextSize.XXXSMALL]: 'tablet:text-xxxsmall',
  [TextSize.XXSMALL]: 'tablet:text-xxsmall',
  [TextSize.XSMALL]: 'tablet:text-xsmall',
  [TextSize.SMALL]: 'tablet:text-small',
  [TextSize.MARKETING_SMALL]: 'tablet:text-marketing_small',
  [TextSize.MID]: 'tablet:text-mid',
  [TextSize.LARGE]: 'tablet:text-large',
  [TextSize.XLARGE]: 'tablet:text-xlarge',
  [TextSize.XXLARGE]: 'tablet:text-xxlarge',
  [TextSize.XXXLARGE]: 'tablet:text-xxxlarge',
  [TextSize.MARKETING_MEGA]: 'tablet:text-marketing_mega',
  [TextSize.MARKETING_XMEGA]: 'tablet:text-marketing_xmega',
  [TextSize.INHERIT]: 'tablet:text-size-inherit',
};

export const TEXT_SIZE_TAILWIND_DESKTOP_VARIANTS: {
  [key in TextSize]: string;
} = {
  [TextSize.XXXSMALL]: 'desktop:text-xxxsmall',
  [TextSize.XXSMALL]: 'desktop:text-xxsmall',
  [TextSize.XSMALL]: 'desktop:text-xsmall',
  [TextSize.SMALL]: 'desktop:text-small',
  [TextSize.MARKETING_SMALL]: 'desktop:text-marketing_small',
  [TextSize.MID]: 'desktop:text-mid',
  [TextSize.LARGE]: 'desktop:text-large',
  [TextSize.XLARGE]: 'desktop:text-xlarge',
  [TextSize.XXLARGE]: 'desktop:text-xxlarge',
  [TextSize.XXXLARGE]: 'desktop:text-xxxlarge',
  [TextSize.MARKETING_MEGA]: 'desktop:text-marketing_mega',
  [TextSize.MARKETING_XMEGA]: 'desktop:text-marketing_xmega',
  [TextSize.INHERIT]: 'desktop:text-size-inherit',
};

export const TEXT_SIZE_TAILWIND_DESKTOP_LARGE_VARIANTS: {
  [key in TextSize]: string;
} = {
  [TextSize.XXXSMALL]: 'desktop_large:text-xxxsmall',
  [TextSize.XXSMALL]: 'desktop_large:text-xxsmall',
  [TextSize.XSMALL]: 'desktop_large:text-xsmall',
  [TextSize.SMALL]: 'desktop_large:text-small',
  [TextSize.MARKETING_SMALL]: 'desktop_large:text-marketing_small',
  [TextSize.MID]: 'desktop_large:text-mid',
  [TextSize.LARGE]: 'desktop_large:text-large',
  [TextSize.XLARGE]: 'desktop_large:text-xlarge',
  [TextSize.XXLARGE]: 'desktop_large:text-xxlarge',
  [TextSize.XXXLARGE]: 'desktop_large:text-xxxlarge',
  [TextSize.MARKETING_MEGA]: 'desktop_large:text-marketing_mega',
  [TextSize.MARKETING_XMEGA]: 'desktop_large:text-marketing_xmega',
  [TextSize.INHERIT]: 'desktop_large:text-size-inherit',
};

export const TEXT_SIZE_TAILWIND_DESKTOP_XXL_VARIANTS: {
  [key in TextSize]: string;
} = {
  [TextSize.XXXSMALL]: 'desktop_xxlarge:text-xxxsmall',
  [TextSize.XXSMALL]: 'desktop_xxlarge:text-xxsmall',
  [TextSize.XSMALL]: 'desktop_xxlarge:text-xsmall',
  [TextSize.SMALL]: 'desktop_xxlarge:text-small',
  [TextSize.MARKETING_SMALL]: 'desktop_xxlarge:text-marketing_small',
  [TextSize.MID]: 'desktop_xxlarge:text-mid',
  [TextSize.LARGE]: 'desktop_xxlarge:text-large',
  [TextSize.XLARGE]: 'desktop_xxlarge:text-xlarge',
  [TextSize.XXLARGE]: 'desktop_xxlarge:text-xxlarge',
  [TextSize.XXXLARGE]: 'desktop_xxlarge:text-xxxlarge',
  [TextSize.MARKETING_MEGA]: 'desktop_xxlarge:text-marketing_mega',
  [TextSize.MARKETING_XMEGA]: 'desktop_xxlarge:text-marketing_xmega',
  [TextSize.INHERIT]: 'desktop_xxlarge:text-size-inherit',
};

export const TEXT_TRANSFORM_TAILWIND_VARIANTS: {
  [key in TextTransform]: string;
} = {
  [TextTransform.UPPERCASE]: 'uppercase',
  [TextTransform.LOWERCASE]: 'lowercase',
  [TextTransform.CAPITALIZE]: 'capitalize',
  [TextTransform.INHERIT]: 'text-transform-inherit',
};

export const TEXT_ALIGN_TAILWIND_VARIANTS: {
  [key in TextAlign]: string;
} = {
  [TextAlign.LEFT]: 'text-left',
  [TextAlign.RIGHT]: 'text-right',
  [TextAlign.CENTER]: 'text-center',
};
export const textVariants = cva('', {
  variants: {
    align: TEXT_ALIGN_TAILWIND_VARIANTS,
    color: TEXT_COLOR_TAILWIND_VARIANTS,
    size: TEXT_SIZE_TAILWIND_VARIANTS,
    sizeTablet: TEXT_SIZE_TAILWIND_TABLET_VARIANTS,
    sizeDesktop: TEXT_SIZE_TAILWIND_DESKTOP_VARIANTS,
    sizeDesktopLarge: TEXT_SIZE_TAILWIND_DESKTOP_LARGE_VARIANTS,
    sizeDesktopXXL: TEXT_SIZE_TAILWIND_DESKTOP_XXL_VARIANTS,
    weight: TEXT_WEIGHT_TAILWIND_VARIANTS,
    transform: TEXT_TRANSFORM_TAILWIND_VARIANTS,
  },
  defaultVariants: {},
});
